import { TreeNode } from '@/model/onSpot/TreeNodes';

export const buildTreeFromArrays = (array: string[]): TreeNode | null => {
    const paths = array.map((path) => path.split('_'));

    if (paths.length < 1) {
        return null;
    }
    const rootId = paths[0][0];
    const root: TreeNode = { id: rootId, treeId: rootId, children: [] };

    paths.forEach((path, index) => {
        let currentNode = root;

        path.slice(1).forEach((id) => {
            let child = currentNode.children.find((node) => node.id === id);

            if (!child) {
                let pathId = '';
                paths[index].forEach((id, idIndex) => {
                    pathId += (idIndex > 0 ? '_' : '') + id;
                });
                child = { id: id, treeId: pathId, children: [] };
                currentNode.children.push(child);
            }

            currentNode = child;
        });
    });

    return root;
};
